import React from 'react';
import { Button, Form, Input, Card, Row, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { Link, useHistory } from 'react-router-dom';
import { GenerateResetPasswordToken } from '../shared/common/graphqlQuery';
import { routeConfig } from '../shared/common/constant';
import { validateNameMessages } from '../shared/hooks/utils';
import { useMutationHook } from '../shared/hooks/useMutationHook';
import AccountPageShowBrand from '../shared/components/accountPageShowBrand/accountPageBrand';

const ForgotPasswordComponent = () => {

    const history = useHistory();
    const goTOUrl = (url) => { history.push(url); }
    const onSubmitted = (result: any) => {
        message.success(result.generateResetPasswordToken);
        goTOUrl(routeConfig.login.path);
    }

    const onError = (error: any) => {
        console.log(error, 'mymy');
    }

    const { callMutation, loading } = useMutationHook(GenerateResetPasswordToken, onSubmitted, onError);
    const onFinish = (values: any) => {
        if (!loading) {
            callMutation({ variables: { email: values.email } });
        }
    }
    return (
        <div className="center">
            <div className="card">
            <AccountPageShowBrand />
                <Card title="Forgot Password" bordered={false} className='loginForm'>
                    <Form name="basic" onFinish={onFinish} validateMessages={validateNameMessages} initialValues={null}>
                        <Form.Item name="email" rules={[{ required: true, whitespace: true, type: 'email' }]} >
                            <Input size="large" placeholder="E-mail" />
                        </Form.Item>

                        <Form.Item>
                            <Button size="large" type="primary" htmlType="submit" style={{ width: '100%' }}>
                                {loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Continue '}
                            </Button>
                        </Form.Item>
                        <div className="sign-up">
                            Return To <Button type="link"><Link to={routeConfig.login.path}>login?</Link></Button>
                        </div>
                    </Form>
                </Card>
            </div>
        </div>
    );
}
export default ForgotPasswordComponent